// ===========================================================================
// API envelope — where the value actually sits in a response.
// ===========================================================================
// The backend `response()` helper answers `{ meta, data: <payload> }`, and most
// CRM controllers pass `{ message, data: X }` as that payload, so the value the
// screen needs sits at `res.data.data.data` (see services/agentsService).
// List endpoints built with `pageResponse` put the array at `res.data.data`.
//
// Reading one level up (`res.data.data`) on a `{ message, data }` payload does
// not fail: it silently yields the wrapper, the screen finds none of its fields
// and renders EMPTY with a 200 from the API. That is how Configuración →
// HubSpot showed no objects, no scopes and no history, and Integraciones no
// providers, in production.
//
// `unwrap` handles both: it peels `{ message, data }` when present and returns
// an already-flat payload (or a pageResponse array) as is.
// ===========================================================================

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function unwrap<T = any>(res: unknown): T {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const payload = (res as any)?.data?.data;
  if (
    payload &&
    typeof payload === "object" &&
    !Array.isArray(payload) &&
    "data" in payload &&
    "message" in payload
  ) {
    return payload.data as T;
  }
  return payload as T;
}

/** `unwrap`, guaranteed to be an array (list endpoints). */
export function unwrapList<T>(res: unknown): T[] {
  const value = unwrap<unknown>(res);
  return Array.isArray(value) ? (value as T[]) : [];
}
